import React from 'react'
import InputButton  from "../InputButton"
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";

const UserForm = (props) =>
{
    const { t } = useTranslation();
    const classInput=(props.background_exist) ? "transparent-input":""
    return(
      <>
          <form onSubmit={props.onSubmitForm} style={{alignItems: 'unset'}}>
              <input
                  type='text'
                  className={classInput}
                  name='user_name'
                  placeholder={t("yourName")}
                  onChange={props.contactHandler}
              />
              <InputMask
                  type='tel'
                  className={classInput}
                  name='user_phone'
                  mask="+9 (999) 999-99-99"
                  maskChar={null}
                  placeholder={t("yourPhone")}
                  onChange={props.contactHandler}
              />
              <InputButton text={t("call")}/>
          </form>
      </>
)
}
export default UserForm